// extracted by mini-css-extract-plugin
export var codes = "CodeInputs-module--codes--e2639";
export var input = "CodeInputs-module--input--bd776";